import React, { useState, useEffect } from "react";
import HeaderText from '../../components/HeaderText'
import Story from '../../components/Story'
import SumStorySSE from '../../components/SumStorySSE'
import StudentStoryPost from '../../components/StudentStoryPost'
import { useParams } from 'react-router-dom';
import { Row, Col, Button } from 'react-bootstrap'
import AuthService from "../../controllers/AuthService";
import PageStep from '../../components/PageStep'
import UserService from "../../controllers/UserService";
import {Helmet} from "react-helmet";


const LivePage = () => {
    const [currentTab, setCurrentTab] = useState('sumstory');
    const [role, setRole] = useState('');
    const { activityId } = useParams();
    const [topicId, setTopicId] = useState('');
    const [btnText, setBtnText] = useState('คำตอบจากนักเรียน');

    useEffect(() => {
        const role = AuthService.getUserRole();
        setRole(role)
        if (role === 'student') {
            setBtnText('ตอบคำถาม');
        }
        UserService.getActivityDetail(activityId).then((res) => {
            if (res.data.data && res.data.data.topic) {
                const topic_id = res.data.data.topic.id
                setTopicId(topic_id)
            }
        })
    }, []);

    const changeTab = (tab) => {
        console.log(tab)
        setCurrentTab(tab)
    }


    return (
        <div>
            <Helmet>
                <title>เริ่มกิจกรรมค้นหาคุณค่าผ่านนิสัยเชิงบวก - Mindsetmaker.co</title>
                <meta property="og:title"       content={`เริ่มกิจกรรมค้นหาคุณค่าผ่านนิสัยเชิงบวก - Mindsetmaker.co`} />
                <meta property="og:description" content={`เริ่มกิจกรรมค้นหาคุณค่าผ่านนิสัยเชิงบวก ประจำชั้น${AuthService.getCurrentUser().room.displayName} ${AuthService.getCurrentUser().domain.displayName}`} />
            </Helmet>
            {/* <Row >
                <Col className="header-text">
                    <HeaderText cardImage="http://placehold.jp/286x180.png" text1="Homeroom" cardTitle="" text2="ห้อง ม.2/1  คุณครูสมหมาย ชายล้วน" />
                </Col>
            </Row> */}
            <Row className="bg-white border-sdb-gray fix-top">
                {(role === 'teacher') &&
                    <Col xs={12} className="main-detail mt-lg-3">
                        <PageStep step="3" />
                    </Col>
                }
                <Col xs={12} className="ReportOverviewPage">
                    <div className="report-overview main-detail mb-2 mb-md-3 w-100">
                        <div className="my-md-3 btn-main-group w-100 text-center">
                            <Button variant="report-menu m-2 py-md-1 btn-repot font-sarabun" onClick={() => changeTab('activity')} className={`${currentTab === 'activity' ? "btn-mm-danger font-weight-600" : "btn-mm-outline-danger"}`} >เรื่องราว</Button>
                            <Button variant="report-menu m-2 py-md-1 btn-repot font-sarabun" onClick={() => changeTab('sumstory')} className={`${currentTab === 'sumstory' ? "btn-mm-danger font-weight-600" : "btn-mm-outline-danger"}`} >{btnText}</Button>
                        </div>
                    </div>
                </Col>
            </Row>
            { topicId && (
                <Row className={`bg-lightness-blue activity ${(currentTab === 'activity') ? "" : "d-none"}`}>
                    <Col xs={12} className="main-detail mb-3 mt-5">
                        <Story topicId={topicId} showQuestion="0" hideStart="1" />
                    </Col>
                </Row>
            )}
            {/* for teacher */}
            <Row className={`bg-lightness-blue sum-activity text-center ${(currentTab === 'sumstory' && role === 'teacher') ? "" : "d-none"}`}>
                <Col xs={12} className="mb-3 mt-5 px-0">
                    <SumStorySSE hideHeader="1" date='activityDate' activityId={activityId} />
                </Col>
            </Row>
            {/* for student */}
            <Row className={`bg-lightness-blue student-activity text-center ${(currentTab === 'sumstory' && role === 'student') ? "" : "d-none"}`}>
                <Col xs={12} className="mt-5 px-0">
                    <StudentStoryPost activityId={activityId} />
                </Col>
            </Row>

        </div>
    );
};


export default LivePage;